import "./App.css";
import { LanguageProvider } from "./LanguageProvider";
import { GeneralProvider } from "./GeneralProvider";
import Mainpage from "./pages/Mainpage/Mainpage";
import LoginPage from "./pages/Auth/LoginPage";
import RegisterPage from "./pages/Auth/RegisterPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ProtectedRoute from "./ProtectedRoute";
import { ToasterProvider } from "./ToasterProvider";
import InvitationHandler from "./pages/InvitationHandler";
import { ThemeProvider } from "./ThemeProvider";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import { useEffect, useState } from "react";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function App() {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // 768px altı cihazları mobil kabul ediyoruz
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <LanguageProvider>
      <ThemeProvider>
        <ToasterProvider>
          <GoogleOAuthProvider clientId={clientId}>
            <div>
              <div className="light-effect"></div>
              <div className="light-effect"></div>
              <div className="light-effect"></div>
              <div className="light-effect"></div>
              <div className="dots"></div>
            </div>
            <Router>
              <GeneralProvider>
                <Routes>
                  <Route path="/" element={<LoginPage />} />
                  <Route path="/channel/:channelUri" element={<LoginPage />} />
                  <Route
                    path="/social-hive/dm/:roomId"
                    element={<LoginPage />}
                  />

                  <Route
                    path="/event/:eventID/details"
                    element={<LoginPage />}
                  />
                  <Route
                    path="event/:eventID/speakers"
                    element={<LoginPage />}
                  />
                  <Route
                    path="event/:eventID/tickets"
                    element={<LoginPage />}
                  />
                  <Route
                    path="/event/:eventID/sponsors"
                    element={<LoginPage />}
                  />


                  <Route path="*" element={<Navigate to="/" replace />} />
                  <Route path="/register" element={<RegisterPage />} />

                  <Route
                    path="/register/event/:eventID/details"
                    element={<RegisterPage />}
                  />
                  <Route
                    path="/register/event/:eventID/speakers"
                    element={<RegisterPage />}
                  />
                  <Route
                    path="/register/event/:eventID/tickets"
                    element={<RegisterPage />}
                  />
                  <Route
                    path="/register/event/:eventID/sponsors"
                    element={<RegisterPage />}
                  />

                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route
                    path="/home"
                    element={<ProtectedRoute element={<Mainpage />} />}
                  />
                  <Route path="/collaborators/invitation/accept/:invitationCode" element={<InvitationHandler />} />
                  <Route path="/collaborators/invitation/reject/:invitationCode" element={<InvitationHandler />} />
                  {/* Kayıtlı olmayan kullanıcı collaborator daveti */}
                  <Route path="/collaborators/invitation/new/:invitationCode" element={<InvitationHandler />} />
                  {/* Proje daveti (sadece kayıtlı kullanıcı) */}
                  <Route path="/projects/invitation/accept/:invitationCode" element={<InvitationHandler />} />
                  <Route path="/projects/invitation/reject/:invitationCode" element={<InvitationHandler />} />
                </Routes>
              </GeneralProvider>
            </Router>
          </GoogleOAuthProvider>
        </ToasterProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
